export { default } from 'mersenne-twister';